(function(){"use strict";
// pv-whatsapp-checkout.js v5 — botón "PEDIR POR WHATSAPP" en cart drawer y /cart
// v5: el clic dispara Purchase en Meta; si el pixel no cargó, se envía por respaldo (imagen de seguimiento).
if(window.__pvWaInit)return;window.__pvWaInit=true;

var PHONE="573170834069";
var PIXEL_ID="2313606036200026";
var MAIN="PEDIR POR WHATSAPP",SUB="Te confirmamos en minutos · Pagas al recibir",LOADING="Abriendo WhatsApp…";
var ICON='<svg class="pv-wa-ico" viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path fill="currentColor" d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.9 15.9 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.1-1.932 2.014-3.182 2.28-.856.18-1.972.324-5.732-1.232-4.812-1.990-7.904-6.876-8.144-7.194-.23-.318-1.932-2.574-1.932-4.908s1.222-3.482 1.656-3.960c.434-.478.948-.598 1.264-.598.316 0 .632.002.908.016.292.016.684-.11 1.070.816.39.94 1.326 3.232 1.442 3.466.116.234.194.508.038.816-.156.318-.234.508-.468.786-.234.278-.49.62-.7.832-.234.234-.478.49-.206.96.272.468 1.212 2 2.602 3.238 1.786 1.59 3.290 2.082 3.758 2.316.468.234.742.194 1.014-.116.272-.318 1.17-1.36 1.482-1.83.312-.468.624-.39 1.054-.234.434.156 2.724 1.284 3.190 1.518.468.234.778.35.894.546.116.194.116 1.138-.274 2.238z"/></svg>';

function btnHTML(){
  return '<div class="pv-wa-wrap"><button type="button" class="pv-wa-btn" data-pv-event="purchase">'+ICON+
    '<span class="pv-wa-txt"><span class="pv-wa-main">'+MAIN+'</span><span class="pv-wa-sub">'+SUB+'</span></span></button></div>';
}

function mountIn(container){
  if(!container||container.querySelector(".pv-wa-wrap"))return;
  var ctas=container.querySelector(".cart__ctas");
  if(ctas)ctas.insertAdjacentHTML("afterend",btnHTML());
  else container.insertAdjacentHTML("beforeend",btnHTML());
}

function hints(){
  document.querySelectorAll('.product__info-container .product-form__submit[name="add"],.pv-sticky-btn').forEach(function(b){
    if(b.querySelector(".pv-wa-hint"))return;
    var s=document.createElement("span");
    s.className="pv-wa-hint";
    s.textContent=b.classList.contains("pv-sticky-btn")?"Pides por WhatsApp":"Finalizas tu pedido por WhatsApp";
    b.appendChild(s);
  });
}

function mount(){
  mountIn(document.querySelector("cart-drawer .drawer__footer"));
  mountIn(document.querySelector("#main-cart-footer .cart__blocks"));
  hints();
}

var pending=0;
function schedule(){if(pending)return;pending=setTimeout(function(){pending=0;try{mount()}catch(e){}},40)}

function money(cents){
  var n=Math.round((cents||0)/100);
  return "$"+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,".");
}

function couponCodes(cart){
  var s={};
  (cart.discount_codes||[]).forEach(function(d){if(d&&d.code&&d.applicable!==false)s[d.code]=1});
  (cart.cart_level_discount_applications||[]).forEach(function(d){if(d&&d.type==="discount_code"&&d.title)s[d.title]=1});
  (cart.items||[]).forEach(function(it){
    (it.line_level_discount_allocations||[]).forEach(function(a){
      var d=a&&a.discount_application;
      if(d&&d.type==="discount_code"&&d.title)s[d.title]=1;
    });
  });
  return Object.keys(s);
}

function buildMessage(cart,ref){
  var L=["Hola Pide Vicio 🍔 Quiero hacer este pedido:","","🧾 Pedido web #"+ref];
  cart.items.forEach(function(it){
    var name=it.product_title||it.title||"";
    if(it.variant_title&&it.variant_title!=="Default Title")name+=" — "+it.variant_title;
    L.push("• "+it.quantity+"x "+name+" — "+money(it.original_line_price));
    var p=it.properties||{};
    Object.keys(p).forEach(function(k){
      var v=p[k];
      if(k.charAt(0)==="_"||v===null||v===undefined||v==="")return;
      if(typeof v==="object")v=JSON.stringify(v);
      L.push("   ↳ "+k+": "+v);
    });
  });
  L.push("");
  L.push("Subtotal: "+money(cart.original_total_price));
  var disc=(cart.original_total_price||0)-(cart.total_price||0);
  if(disc>0)L.push("Descuento web: -"+money(disc));
  var codes=couponCodes(cart);
  if(codes.length)L.push("Cupón: "+codes.join(", "));
  L.push("Domicilio: según tu zona (me confirman el valor)");
  L.push("Total a pagar: "+money(cart.total_price)+" + domicilio");
  L.push("");
  L.push("Por favor tómame los datos de entrega 🙏");
  return L.join("\n");
}

// Respaldo: si el pixel (fbq) no está cargado, el evento se envía igual con una imagen de seguimiento de Meta.
function pixelBeacon(ev,eid,value,ids,num){
  try{
    var q="id="+PIXEL_ID+"&ev="+encodeURIComponent(ev)+"&eid="+encodeURIComponent(eid)+
      "&dl="+encodeURIComponent(location.href)+
      "&cd[value]="+value+"&cd[currency]=COP&cd[content_type]=product"+
      "&cd[content_ids]="+encodeURIComponent(JSON.stringify(ids))+
      "&cd[num_items]="+(num||0)+"&noscript=1";
    var img=new Image(1,1);
    img.src="https://www.facebook.com/tr?"+q;
  }catch(e){}
}

function track(cart,ref){
  var value=Math.round((cart.total_price||0)/100);
  var ids=cart.items.map(function(i){return String(i.variant_id)});
  var sentByPixel=false;
  try{
    if(typeof window.fbq==="function"){
      window.fbq("track","InitiateCheckout",{value:value,currency:"COP",num_items:cart.item_count,content_ids:ids,content_type:"product"},{eventID:ref+"-ic"});
      window.fbq("track","Purchase",{value:value,currency:"COP",num_items:cart.item_count,content_ids:ids,content_type:"product",order_ref:ref},{eventID:ref+"-p"});
      window.fbq("trackCustom","PedidoWhatsApp",{value:value,currency:"COP",order_ref:ref},{eventID:ref});
      sentByPixel=true;
    }
  }catch(e){}
  if(!sentByPixel){
    pixelBeacon("InitiateCheckout",ref+"-ic",value,ids,cart.item_count);
    pixelBeacon("Purchase",ref+"-p",value,ids,cart.item_count);
  }
  try{
    if(window.ttq&&typeof window.ttq.track==="function"){
      var ttData={value:value,currency:"COP",content_type:"product",contents:cart.items.map(function(i){
        return {content_id:String(i.variant_id),content_name:i.product_title,quantity:i.quantity,price:Math.round((i.final_price||0)/100)};
      })};
      window.ttq.track("CompletePayment",ttData,{event_id:ref+"-p"});
      window.ttq.track("PedidoWhatsApp",ttData,{event_id:ref});
    }
  }catch(e){}
  try{
    if(typeof window.gtag==="function"){
      window.gtag("event","begin_checkout",{currency:"COP",value:value,order_ref:ref,items:cart.items.map(function(i){
        return {item_id:String(i.variant_id),item_name:i.product_title,item_variant:i.variant_title||"",price:Math.round((i.final_price||0)/100),quantity:i.quantity};
      })});
    }
  }catch(e){}
  try{
    if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==="function"){
      window.Shopify.analytics.publish("pedido_whatsapp",{order_ref:ref,value:value,currency:"COP",num_items:cart.item_count,content_ids:ids});
    }
  }catch(e){}
}

// Mismo carrito = misma referencia y mismo eventID, así Meta no cuenta dos compras si el cliente vuelve y da clic otra vez.
function refFor(cart){
  var sig=(cart.token||"")+"|"+cart.total_price+"|"+cart.item_count;
  try{
    var saved=JSON.parse(localStorage.getItem("pvWaRef")||"null");
    if(saved&&saved.sig===sig&&saved.ref)return saved.ref;
  }catch(e){}
  var ref="PV-"+(1000+Math.floor(Math.random()*9000));
  try{localStorage.setItem("pvWaRef",JSON.stringify({sig:sig,ref:ref}))}catch(e){}
  return ref;
}

function setLoading(b,on){
  b.disabled=on;
  b.classList.toggle("is-loading",on);
  var m=b.querySelector(".pv-wa-main");
  if(m)m.textContent=on?LOADING:MAIN;
}

function go(b){
  setLoading(b,true);
  fetch("/cart.js",{headers:{Accept:"application/json"},cache:"no-store"})
    .then(function(r){return r.json()})
    .then(function(cart){
      if(!cart||!cart.item_count||!cart.items||!cart.items.length){setLoading(b,false);return}
      var ref=refFor(cart);
      // wa.me redirige a api.whatsapp.com y en ese salto rompe los emojis (llegan como �): se usa el destino final directo.
      var url="https://api.whatsapp.com/send?phone="+PHONE+"&text="+encodeURIComponent(buildMessage(cart,ref));
      try{track(cart,ref)}catch(e){}
      // Los navegadores in-app de Instagram/Facebook bloquean window.open: se navega en la misma pestaña.
      setTimeout(function(){window.location.href=url},300);
    })
    .catch(function(){setLoading(b,false)});
}

document.addEventListener("click",function(e){
  var b=e.target&&e.target.closest&&e.target.closest(".pv-wa-btn");
  if(!b)return;
  e.preventDefault();
  if(!b.disabled)go(b);
});

window.addEventListener("pageshow",function(){
  document.querySelectorAll(".pv-wa-btn").forEach(function(b){setLoading(b,false)});
});

window.pvWaBuildMessage=buildMessage;

function init(){
  mount();
  try{new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true})}catch(e){}
}
document.readyState==="loading"?document.addEventListener("DOMContentLoaded",init):init();
})();